var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-grid',{ref:"vxeGrid",attrs:{"auto-resize":"","highlight-hover-row":"","data":_vm.tableData,"columns":_vm.tableColumns,"loading":_vm.loading,"height":300,"size":"mini","resizable":"","border":"","header-cell-style":function () {
      return {
        backgroundColor: '#bd94c1',
        color: '#ffffff',
      }
    }},scopedSlots:_vm._u([{key:"top",fn:function(){return [_vm._t("header")]},proxy:true}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }